export default __webpack_public_path__ + "static/media/Shadow's Tunic of the Sundered Crown.1dbbf52e.jpg";